// extracted by mini-css-extract-plugin
export default {"container":"Description_container__3+W6c"};